"use client";

import { useEffect, useRef } from "react";
import { track } from "@/libs/analytics";
import type { CrossSellOfferId, CrossSellPlacement } from "@/libs/cross-sell-v2";

export function useCrossSellImpression(offerId: CrossSellOfferId, placement: CrossSellPlacement) {
  const tracked = useRef(false);

  useEffect(() => {
    if (tracked.current) return;
    tracked.current = true;
    track("xsell_impression", "monetization", {
      offer: offerId,
      placement,
    });
  }, [offerId, placement]);
}

export function trackCrossSellClick(offerId: CrossSellOfferId, placement: CrossSellPlacement) {
  track("xsell_click", "monetization", {
    offer: offerId,
    placement,
  });
}

export function trackCrossSellTeaseView(offerId: CrossSellOfferId, placement: CrossSellPlacement) {
  track("xsell_tease_view", "monetization", {
    offer: offerId,
    placement,
  });
}
